import { CareOrder } from '../../types';
import { CustomerBalance, CustomerTransaction } from '../../types/CustomerBalance';
import { CustomerExecutionReport } from '../../types/CustomerExecutionReport';
import { CustomerOrder } from '../../types/CustomerOrder';
import { CustomerQuote } from '../../types/CustomerQuote';
import { CustomerTrade } from '../../types/CustomerTrade';
import { CustomerUser } from '../../types/CustomerUser';
import { ExecutionReport } from '../../types/ExecutionReport';
import { FixingIndexRow } from '../../types/FixingIndex';
import { Order } from '../../types/Order';
import { Quote } from '../../types/Quote';

export type DetailsDrawerEntity =
  | Order
  | Quote
  | ExecutionReport
  | CustomerOrder
  | CustomerExecutionReport
  | CustomerQuote
  | CustomerTrade
  | CustomerBalance
  | CustomerUser
  | CustomerTransaction
  | CareOrder
  | FixingIndexRow;

export const isDetailsDrawerEntity = (entity: any): entity is DetailsDrawerEntity =>
  entity instanceof Order ||
  entity instanceof Quote ||
  entity instanceof ExecutionReport ||
  entity instanceof CustomerOrder ||
  entity instanceof CustomerExecutionReport ||
  entity instanceof CustomerQuote ||
  entity instanceof CustomerTrade ||
  entity instanceof CustomerBalance ||
  entity instanceof CustomerUser ||
  entity instanceof CustomerTransaction ||
  entity instanceof CareOrder ||
  entity instanceof FixingIndexRow;
